module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_f_piebald.912ed303.png";